import { useSuspenseQuery } from '@tanstack/react-query';

import { PublicationInfluence } from '@/module/Journal/components/PublicationInfluence';

import { Id } from '@feature/utils';

import { getAbstractInfluenceOptions } from '../model/AbstractQuery';

interface AbstractInfluenceProps {
  abstractId: Id;
  hideTemporary?: boolean;
}

export function AbstractInfluence({ abstractId, hideTemporary }: AbstractInfluenceProps) {
  const { data } = useSuspenseQuery(getAbstractInfluenceOptions(abstractId));

  return (
    <PublicationInfluence
      hideTemporary={hideTemporary}
      data={data}
    />
  );
}
